module.exports = __webpack_public_path__ + "static/media/Image_27.e180e669.png";